import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../common/Reveal";

const FIELDS = [
  { key: "whoFor", label: "Who it is for" },
  { key: "problem", label: "The typical problem" },
  { key: "howWeHelp", label: "How IAG helps" },
  { key: "deliverables", label: "Possible deliverables" },
];

export const SolutionBlock = ({ solution, index }) => (
  <section
    id={solution.id}
    className={`scroll-mt-28 py-20 lg:py-28 ${index % 2 === 1 ? "bg-sand" : "bg-white"}`}
    data-testid={`solution-${solution.id}`}
  >
    <div className="container-site">
      <Reveal>
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="font-serif text-5xl text-gold/70" aria-hidden="true">
              {solution.letter}
            </p>
            <h2 className="mt-4 font-serif text-3xl tracking-tight text-navy sm:text-4xl">
              {solution.title}
            </h2>
            <p className="mt-4 font-serif text-base italic text-emerald">{solution.tagline}</p>
            <ul className="mt-8 flex flex-wrap gap-2" aria-label="Services">
              {solution.services.map((s) => (
                <li
                  key={s}
                  className="border border-navy/15 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-ink/70"
                >
                  {s}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-8">
            <dl className="grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2">
              {FIELDS.map((f) => (
                <div key={f.key} className="bg-white p-7">
                  <dt className="text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
                    {f.label}
                  </dt>
                  <dd className="mt-3 text-sm leading-relaxed text-ink/75">{solution[f.key]}</dd>
                </div>
              ))}
            </dl>
            <Link
              to="/contact"
              className="btn-primary mt-10"
              data-testid={`solution-cta-${solution.id}`}
            >
              Discuss Your Challenge <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
